import { NgModule } from '@angular/core';
import { Routes, RouterModule, DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Utilities } from './services/utilities';
import { HomeComponent } from './feature-modules/home/home.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { LoginComponent } from './components/shared-components/login/login.component';
import { AuthGuard } from './services/auth-guard.service';
import { UserCounterComponent } from './components/shared-components/user-counter/user-counter.component';
import { ClaimFinalizeComponent } from './feature-modules/claim/finalize/claim-finalize.component';
import { ClaimVerificationComponent } from './feature-modules/claim/verification/claim-verification.component';
import { ClaimComponent } from './feature-modules/claim/claim.component';
import { NavigateComponent } from './feature-modules/navigate/navigate.component';
import { ContentPageComponent } from './feature-modules/content-pages/content-page/content-page.component';
import { MinimalLayoutComponent } from './components/layout-components/minimal-layout/minimal-layout.component';
import { MainLayoutComponent } from './components/layout-components/main-layout/main-layout.component';
import { ManualClaimComponent } from './feature-modules/claim/manual-claim/manual-claim.component';

//import { NgxHotjarModule, NgxHotjarRouterModule } from 'ngx-hotjar';                                                  // 08-22-2021 - dwn: added per: https://github.com/maxandriani/ngx-hotjar

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const possibleSeparators = /[?;#]/;
    const indexOfSeparator = url.search(possibleSeparators);
    let processedUrl: string;

    if (indexOfSeparator > -1) {
      const separator = url.charAt(indexOfSeparator);
      const urlParts = Utilities.splitInTwo(url, separator);
      urlParts.firstPart = urlParts.firstPart.toLowerCase();

      processedUrl = urlParts.firstPart + separator + urlParts.secondPart;
    } else {
      processedUrl = url.toLowerCase();
    }

    return super.parse(processedUrl);
  }
}

const routes: Routes = [
  {
    path: '',
    redirectTo: '/navigating',
    pathMatch: 'full'
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      //Until we use angular 9 as the main home page route to navigating interim page...
      { path: 'navigating', pathMatch: 'full', component: NavigateComponent, data: { title: 'Navigating...' } },
      // { path: '', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'Home' } },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'Home' } },
      { path: 'users', component: UserCounterComponent, canActivate: [AuthGuard], data: { title: 'User Counter' } },
      { path: 'login', component: LoginComponent, data: { title: 'Login' }},
      {
          path: 'register',
          loadChildren: () => import('./feature-modules/register/register.module').then(m => m.RegisterModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./feature-modules/profiles/profiles.module').then(m => m.ProfilesModule)
      },
      {
        path: 'claim',
        component: ClaimComponent,
        //loadChildren: () => import('./feature-modules/claim/claim.module').then(m => m.ClaimModule),
        children: [
          {
            path: 'finalize',                                                                                           //Finalize entry point
            component: ClaimFinalizeComponent,
          },
          {
            path: 'manualcomplete',                                                                                     //Manual Claim
            component: ManualClaimComponent,
          },
          {
          path: '',                                                                                                     // Verification
            component: ClaimVerificationComponent,
          },
        ],
      }
    ]
  },
  {
    path: '',
    component: MinimalLayoutComponent,
    children: [
      { path: 'content', component: ContentPageComponent },
      { path: 'content/:key', component: ContentPageComponent },
      { path: '**', component: PageNotFoundComponent, data: { title: 'Page not found' }}
    ]
  },
];

@NgModule({
  imports:
    //[NgxHotjarModule.forRoot(envorinment.hj), NgxHotjarRouterModule],                                                 // 08-22-2021 - dwn: added per: https://github.com/maxandriani/ngx-hotjar
    [RouterModule.forRoot(routes
    , {
      enableTracing: true,                                                                                              // <-- debugging purposes only
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
